import React from 'react';

import {
  Title,
  Paper,
  Stack,
  Group,
  Button
} from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import CallerForm from '../components/caller/CallerForm';

const AddCaller: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    void navigate('/callers');
  };

  const handleCancel = () => {
    void navigate('/callers');
  };

  return (
    <Stack gap="md">
      <Group align="center" justify="space-between">
        <Title order={1}>Add New Caller</Title>
        <Button variant="outline" onClick={() => void navigate('/callers')}>
          Back to All Callers
        </Button>
      </Group>

      <Paper withBorder p="xl">
        <Stack gap="lg">
          <CallerForm
            mode="add"
            onCancel={handleCancel}
            onSuccess={handleSuccess}
          />
        </Stack>
      </Paper>
    </Stack>
  );
};

export default AddCaller;
